import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const PaymentServices = {
    // bookingList: async (data) => {
    //     console.log("data:", data);
    //     const queryParams = new URLSearchParams();
        
    //     // Basic pagination and sorting parameters
    //     queryParams.append('page', data.page + 1);
    //     queryParams.append('limit', data.limit);
        
    //     // Search key
    //     if (data.filters.searchKey) {
    //         queryParams.append('searchKey', data.filters.searchKey);
    //     }
        
    //     // Sorting
    //     if (data.filters.sortKey) {
    //         queryParams.append('sortKey', data.filters.sortKey);
    //         queryParams.append('sortDirection', data.filters.sortDirection);
    //     }
        
    //     // Status filter - More robust handling
    //     if (data.filters.status && data.filters.status !== 'all') {
    //         // Handle both string and array cases
    //         const statuses = Array.isArray(data.filters.status) 
    //             ? data.filters.status 
    //             : [data.filters.status];
            
    //         statuses.forEach(status => {
    //             queryParams.append('bookingStatus', status);
    //         });
    //     }
        
    //     // Additional multi-column filters
    //     if (data.filters.filterOptions) {
    //         data.filters.filterOptions.forEach((filter, index) => {
    //             if (filter.fieldName && filter.value) {
    //                 queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
    //                 queryParams.append(`filters[${index}][operator]`, filter.operator);
    //                 queryParams.append(`filters[${index}][value]`, filter.value);
                    
    //                 if (index !== 0) {
    //                     queryParams.append(`filters[${index}][andOr]`, filter.andOr);
    //                 }
                    
    //                 if (filter.operator === 'between') {
    //                     queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
    //                 }
    //             }
    //         });
    //     }
        
    //     console.log("query string:", queryParams.toString());
        
    //     // Construct the full URL
    //     const url = `${Helpers.URL()}/api/admin/service-booking/list?${queryParams.toString()}`;
    
    //     // Make the API call
    //     return await commonRequest("get", url, {}, Helpers.token());
    // },

    // bookingListToExport:async (data) => {
    //     console.log("data:", data);
    //     const queryParams = new URLSearchParams();
        
    //     // Search key
    //     if (data.filters.searchKey) {
    //         queryParams.append('searchKey', data.filters.searchKey);
    //     }
        
    //     // Sorting
    //     if (data.filters.sortKey) {
    //         queryParams.append('sortKey', data.filters.sortKey);
    //         queryParams.append('sortDirection', data.filters.sortDirection);
    //     }
        
    //     // Status filter - More robust handling
    //     if (data.filters.status && data.filters.status !== 'all') {
    //         // Handle both string and array cases
    //         const statuses = Array.isArray(data.filters.status) 
    //             ? data.filters.status 
    //             : [data.filters.status];
            
    //         statuses.forEach(status => {
    //             queryParams.append('bookingStatus', status);
    //         });
    //     }
        
    //     // Additional multi-column filters
    //     if (data.filters.filterOptions) {
    //         data.filters.filterOptions.forEach((filter, index) => {
    //             if (filter.fieldName && filter.value) {
    //                 queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
    //                 queryParams.append(`filters[${index}][operator]`, filter.operator);
    //                 queryParams.append(`filters[${index}][value]`, filter.value);
                    
    //                 if (index !== 0) {
    //                     queryParams.append(`filters[${index}][andOr]`, filter.andOr);
    //                 }
                    
    //                 if (filter.operator === 'between') {
    //                     queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
    //                 }
    //             }
    //         });
    //     }
        
    //     console.log("query string:", queryParams.toString());
        
    //     // Construct the full URL
    //     const url = `${Helpers.URL()}/api/admin/service-booking/export-list?${queryParams.toString()}`;
    
    //     // Make the API call
    //     return await commonRequest("get", url, {}, Helpers.token());
    // }, 
    lastPaymentRecords: async (bookingId) => {
        return await commonRequest("get", `${Helpers.URL()}/api/v2/admin/booking-payment-records/last-record/${bookingId}`, {}, Helpers.token());
    },
    createPaymentRecord: async (data) => {
        return await commonRequest("post", `${Helpers.URL()}/api/v2/admin/booking-payment-records/add`, data, Helpers.token());
    },
    fetchPaymentRecordList: async(data) =>{
        console.log("data",data);
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        queryParams.append('sortBy', data.filters.sortBy);            
        queryParams.append('sortType', data.filters.sortType || 'desc');
        

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());        
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/booking-payment-records/all-records?${queryParams.toString()}`,{}, Helpers.token());      
    },
    updatePaymentRecord: async (data,id) => {
        return await commonRequest("put", `${Helpers.URL()}/api/v2/admin/booking-payment-records/update-record/${id}`, data, Helpers.token());
    },
    fetchPendingAmount: async (bookingId) => {
        return await commonRequest("get", `${Helpers.URL()}/api/v2/admin/booking-payment-records/pending-amount/${bookingId}`, {}, Helpers.token());
    },
    fetchBookingPaymentRecords: async (bookingId) => {
        return await commonRequest("get", `${Helpers.URL()}/api/v2/admin/booking-payment-records/record-details-by-booking/${bookingId}`, {}, Helpers.token());
    }
}